/**
 * @generated SignedSource<<79c50a43bbaa5e1fd211dd5e481120a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedRewards_charge$data = {
  readonly cashback: {
    readonly receiver: {
      readonly taxIDObscured: {
        readonly taxID: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly status: string | null | undefined;
    readonly value: number | null | undefined;
  } | null | undefined;
  readonly cashbackExclusive: {
    readonly receiver: {
      readonly taxIDObscured: {
        readonly taxID: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly status: string | null | undefined;
    readonly value: number | null | undefined;
  } | null | undefined;
  readonly payer: {
    readonly taxIDObscured: {
      readonly taxID: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly redeemedCashbackExclusive: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly receiver: {
          readonly taxIDObscured: {
            readonly taxID: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly value: number | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly " $fragmentType": "PaymentLinkCompletedRewards_charge";
};
export type PaymentLinkCompletedRewards_charge$key = {
  readonly " $data"?: PaymentLinkCompletedRewards_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedRewards_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TaxIDObscured",
    "kind": "LinkedField",
    "name": "taxIDObscured",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "receiver",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedRewards_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Cashback",
      "kind": "LinkedField",
      "name": "cashback",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Cashback",
      "kind": "LinkedField",
      "name": "cashbackExclusive",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CashbackConnection",
      "kind": "LinkedField",
      "name": "redeemedCashbackExclusive",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CashbackEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Cashback",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "payer",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "2192013d551661d38aad861ddc3fa344";

export default node;
